const Colorapps = {
  // Text colors
  textprimary: "#f7fcf9",
  textsecondary: "#050806",

  // Theme colors
  themeprimary: "#0da29a",
  themesecondary: "#065586",
  themeaccent: "#ffa726", // Highlight or accent color for buttons, icons, etc.

  // Background colors
  backgroundtheme: "rgba(241, 86, 42)",
  backgroundlight: "#f1f8f5", // Light background for sections
  backgrounddark: "#021f26", // Dark background for footer or headers

  // Border and shadow colors
  bordercolor: "#d1d5db", // Subtle border color for cards or sections
  shadowcolor: "rgba(0, 0, 0, 0.2)", // Shadow color for elevation
};

export default Colorapps;
